import { Ticket } from "lucide-react";
import { trackEvent } from "../config";
import { useReveal } from "../hooks/useReveal";

export default function FinalCTA() {
  const ref = useReveal();

  return (
    <section className="py-40 relative overflow-hidden">
      <div className="container mx-auto px-6 relative z-10">
        <div ref={ref} className="reveal text-center max-w-3xl mx-auto">
          <h2 className="text-6xl md:text-8xl font-serif leading-none mb-10">
            Don't miss <br />
            <span className="italic text-[#C9ED00]">this night.</span>
          </h2>
          <p className="text-xl text-white/50 mb-14">
            Ram Miriyala. Full band. One historic night in Raleigh.
            <br />Tickets are selling fast — don't wait.
          </p>
          <a
            href="/ram-raleigh-deal"
            onClick={() => trackEvent("InitiateCheckout")}
            className="group relative inline-flex items-center justify-center px-12 py-6 bg-amber-500 text-black rounded-full font-bold text-lg transition-all duration-300 hover:bg-amber-400 hover:scale-110 cursor-pointer"
          >
            Claim Your Tickets
            <Ticket className="ml-3 w-5 h-5" />
          </a>
        </div>
      </div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full opacity-10 pointer-events-none glow-radial" />
    </section>
  );
}
